// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hDjgJPicbfWCeB8YDsT_6 {\n    color: #9D9D9D;\n}\n\n._8CqpCuFJqjZWVbcwmZIJJ {\n    margin: 6px 0 0 30px;\n    font-size: 28px;\n    cursor: pointer;\n}\n", ""]);
// Exports
exports.locals = {
	"timestamp": "hDjgJPicbfWCeB8YDsT_6",
	"downloadIcon": "_8CqpCuFJqjZWVbcwmZIJJ"
};
module.exports = exports;
